<div class="flex flex-col gap-1" data-test-class="filter-group">
	<label [for]="inputId()" class="font-semibold">
		{{ 'compositions.filters.type.' + inputId() + '.label' | translate }}
	</label>
	<vp-input
		[formControl]="formControl"
		[initialValue]="value()"
		[inputId]="inputId()"
		[name]="inputId()"
		(change)="commit()"
		(focusout)="commit()"
		(keydown.enter)="commit()"
		type="number"
	/>
</div>
